import Main from './filtr/Main';

function App() {
  return (
   <Main/>
  );
}

export default App;
